import { useTranslation } from 'react-i18next';
import { useExperiences } from 'core/contexts/experienceV2';
import { CheckboxComponent } from '@utriper/core-ui';
import { DeleteOutline } from '@mui/icons-material';
import { Grid2, IconButton, Tooltip, Typography } from '@mui/material';

const ResourceCard = ({ id, experienceId, name, notificationEmail, notificationWhatsapp, email, mobilePhone, onRemove = () => {}, isCategory = false }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_resource.${key}`);
    const { updateResource } = useExperiences();
    const resourceData = {
        id,
        experienceId,
        isCategory,
    };

    const handleChangeNotificationEmail = (newValue) => {
        updateResource({
            ...resourceData,
            notificationData: {
                notificationEmail: newValue,
                notificationWhatsapp,
            },
        });
    };

    const handleChangeNotificationWhatsapp = (newValue) => {
        updateResource({
            ...resourceData,
            notificationData: {
                notificationEmail,
                notificationWhatsapp: newValue,
            },
        });
    };

    return (
        <Grid2
            size={12}
            sx={{
                padding: '1em',
                borderRadius: '.25em',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                border: 'solid #13131340 1px',
                boxShadow: 'var(--shadow-card)',
                backgroundColor: '#fff',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.05)',
                },
            }}
        >
            <Grid2 container size={12} justifyContent="space-between" alignItems="center">
                <Typography fontSize={20} fontWeight={600} sx={{ color: '#131313' }} noWrap>
                    {name}
                </Typography>
                <Tooltip title="Eliminar">
                    <IconButton aria-label="delete" size="small" color="error" onClick={() => onRemove(experienceId, id)}>
                        <DeleteOutline />
                    </IconButton>
                </Tooltip>
            </Grid2>
            <Grid2 container size={12} spacing={1}>
                <Grid2 size={6}>
                    <CheckboxComponent labelComponent={translate('notification_email')} name="notificationEmail" checked={notificationEmail} onChange={handleChangeNotificationEmail} disabled={!email && !isCategory} />
                </Grid2>
                <Grid2 size={6}>
                    <CheckboxComponent labelComponent={translate('notification_whatsapp')} name="notificationWhatsapp" checked={notificationWhatsapp} onChange={handleChangeNotificationWhatsapp} disabled={!mobilePhone && !isCategory} />
                </Grid2>
            </Grid2>
        </Grid2>
    );
};

export default ResourceCard;
